// extracted by mini-css-extract-plugin
export default {"inputRoot":"autocomplete_inputRoot__5wwey"};